import CustomModel from '../popupModel/CustomModel/CustomModel';

import React from 'react';
import {useTranslation} from 'react-i18next';

function NetworkChecker(props) {
  const {t} = useTranslation();
  const [title, setTitle] = React.useState('');
  const [subTitle, setSubTitle] = React.useState('');
  const [offlineModalVisibility, setOfflineModalVisibility] =
    React.useState(false);

  const renderOfflinePopup = () => (
    <CustomModel
      className="offlineModal"
      title={title}
      subTitle={subTitle}
      primaryButtonText={t('OK')}
      primaryClickHandler={() => {
        setOfflineModalVisibility(false);
      }}
      isVisible={offlineModalVisibility}
    />
  );

  React.useEffect(() => {
    const handleOnline = () => {
      setTitle(t('ONLINE_TITLE'));
      setSubTitle(t('ONLINE_SUBTITLE'));
      setOfflineModalVisibility(true);
      props.setNetworkStatus(false);
    };
    const handleOffline = () => {
      setTitle(t('OFFLINE_TITLE'));
      setSubTitle(t('OFFLINE_SUBTITLE'));
      setOfflineModalVisibility(true);
      props.setNetworkStatus(true);
    };

    globalThis.addEventListener('online', handleOnline);
    globalThis.addEventListener('offline', handleOffline);

    return () => {
      globalThis.removeEventListener('online', handleOnline);
      globalThis.removeEventListener('offline', handleOffline);
    };
  }, []);
  return <div>{renderOfflinePopup()}</div>;
}

export default NetworkChecker;
